import styled from 'styled-components';
export const Loader = styled.div`
  display:flex;
  border: ${props => props.borderSize ? `${props.borderSize}solid rgba(65 , 87 , 187 , 0.45)` : '10px solid rgba(65 , 87 , 187 , 0.45)'} ;
  /* margin: 5px 5px 5px 5px; */
  border-radius:  50%;
  border-top: ${props => props.borderSize || '10px'} solid ${props => props.theme.primary};
  width: ${props => props.height ? `${props.height / 2}px` : '25px'};
  height: ${props => props.height ? `${props.height / 2}px` : '25px'};
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`